import { ActivityEventRow, EventIconCircle, UserName } from "./ActivityEventRow";

import { Row } from "@/components";

import { useGetUser } from "@/hooks/queries/useGetUser";
import { activityTypography } from "@/lib/constants";
import type { UserPermanentStatusChange } from "@/types";

const PERMANENT_STATUS_CLASSNAME = "italic text-red-500 pr-1";

export const PermanentStatusChangeEvent = ({
  candidateFullName,
  currentUserId,
  permanentStatusChange,
}: {
  candidateFullName: string;
  currentUserId: number;
  permanentStatusChange: UserPermanentStatusChange;
}) => {
  /* Database CRUD Operations */
  // Read
  const { data: user } = useGetUser({
    userId: permanentStatusChange.stafferId,
  });

  /* Helpers */
  // TODO STF-307: from/to statuses are nullable but not typed so via nova tRPC.
  const fromStatus = permanentStatusChange.fromStatus as string | null;
  const toStatus = permanentStatusChange.toStatus as string | null;
  const candidateEmphasis = (
    <span className={activityTypography.emphasis}>{candidateFullName}</span>
  );

  /* Render */
  const renderSentence = () => {
    if (fromStatus === null && toStatus !== null) {
      return (
        <>
          <UserName currentUserId={currentUserId} user={user} /> set a permanent
          status of{" "}
          <span className={PERMANENT_STATUS_CLASSNAME}>{toStatus}</span> for{" "}
          {candidateEmphasis}
        </>
      );
    }
    if (toStatus === null && fromStatus !== null) {
      return (
        <>
          <UserName currentUserId={currentUserId} user={user} /> cleared the
          permanent status of{" "}
          <span className={PERMANENT_STATUS_CLASSNAME}>{fromStatus}</span> from{" "}
          {candidateEmphasis}
        </>
      );
    }
    if (fromStatus !== null && toStatus !== null) {
      return (
        <>
          <UserName currentUserId={currentUserId} user={user} /> changed
          permanent status for {candidateEmphasis} from{" "}
          <span className={PERMANENT_STATUS_CLASSNAME}>{fromStatus}</span> to{" "}
          <span className={PERMANENT_STATUS_CLASSNAME}>{toStatus}</span>
        </>
      );
    }
    return null;
  };

  const render = () => {
    return (
      <ActivityEventRow
        createdAt={permanentStatusChange.createdAt}
        icon={
          <EventIconCircle className="border border-primary-900">
            <Row className="items-center justify-center text-xl font-medium text-red-600">
              !
            </Row>
          </EventIconCircle>
        }
      >
        {renderSentence()}
      </ActivityEventRow>
    );
  };

  return render();
};
